import { Badge, Grid, Paper, Typography } from '@mui/material'
import { Control } from 'react-hook-form'
import config from '../../../Config/clientConfig.json'
import WSTextField from '../../../Components/TextBox/WSTextBox'
import WSPhone from '../../../Components/Phone/WSPhone'
import WSDateField from '../../../Components/DateField/WSDateField'
import WSSelectField from '../../../Components/Select/WSSelect'

const DigitalCardCustomerForm = ({ control }: { control: Control }) => {
    return (
        <Paper elevation={0} sx={{
            p: 2.5,
            mb: 3,
            borderRadius: 2,
            border: '1px solid',
            borderColor: '#e2e8f0',
            backgroundColor: '#f8fafc'
        }}>
            <Typography variant="subtitle1" gutterBottom sx={{
                fontWeight: 600,
                color: '#334155',
                mb: 2,
                display: 'flex',
                alignItems: 'center'
            }}>
                <Badge sx={{
                    background: "#3b82f6",
                    color: "white",
                    borderRadius: "50%",
                    width: 22,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1.5,
                    fontSize: "0.7rem"
                }}>
                    2
                </Badge>
                Customer Details
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <WSTextField
                        id="customerName"
                        label="Customer Name"
                        name='customerName'
                        control={control}
                        rules={{ required: 'Customer Name is required' }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <WSPhone
                        id='mobileNumber'
                        label="Mobile Number"
                        name='mobileNumber'
                        control={control}
                        rules={{ required: 'Mobile Number is required' }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <WSTextField
                        id='emailID'
                        label="Email Address"
                        name='emailAddress'
                        control={control}
                        rules={{ required: false }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <WSTextField
                        control={control}
                        id="addressOne"
                        rules={{ required: "Address is required" }}
                        name="addressOne"
                        label="Address Line 1"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <WSTextField
                        control={control}
                        id="addressTwo"
                        rules={{ required: false }}
                        name="addressTwo"
                        label="Address Line 2 (Optional)"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <WSTextField
                        control={control}
                        id="city"
                        rules={{ required: "City is required" }}
                        defaultValue={'Kannur'}
                        name="city"
                        label="City"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <WSSelectField
                        options={config.stateConfig.staticOptionData}
                        rules={{ required: "State is required" }}
                        id="state"
                        control={control}
                        defaultValue={config.stateConfig.staticOptionData[12].value}
                        label="State"
                        name="state"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <WSTextField
                        control={control}
                        id="postalCode"
                        rules={{ required: "Postal code is required" }}
                        name="postalCode"
                        label="Postal Code"
                        maxLength={6}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <WSDateField
                        id="anniversary"
                        name="anniversary"
                        label={"Anniversary"}
                        dateFormat="YYYY/MM/DD"
                        control={control}
                        defaultValue={null}
                        rules={{ required: false }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                backgroundColor: 'white'
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default DigitalCardCustomerForm